module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-box__outer"
  }, [_c('div', {
    staticClass: "basic-box__title text_center"
  }, [_vm._v("Особые дни")]), _vm._v(" "), _c('div', {
    staticClass: "basic-box__inner"
  }, [_vm._l((_vm.days), function(day) {
    return (_vm.days.length) ? _c('div', {
      staticClass: "widget profile-clinic__widget flex"
    }, [_c('div', {
      staticClass: "widget__inner widget__inner_day widget__inner_date"
    }, [_c('div', {
      staticClass: "widget__day"
    }, [_vm._v(_vm._s(_vm._f("moment")([day.begin, "X"], 'DD.MM')))])]), _vm._v(" "), _c('div', {
      staticClass: "widget__inner widget__inner_time-table flex"
    }, [_c('div', {
      staticClass: "widget__time_item flex justify-center"
    }, [(day.type.indexOf('not_work') !== -1) ? _c('div', {
      staticClass: "widget__time"
    }, [_vm._v("Не работает")]) : _c('div', {
      staticClass: "widget__time",
      on: {
        "click": function($event) {
          _vm.editTime(day)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("moment")([day.begin, 'X'], 'HH:mm')) + " - " + _vm._s(_vm._f("moment")([day.end, 'X'], 'HH:mm')) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('i', {
      staticClass: "widget__icon widget__icon_close icon ion-android-close",
      on: {
        "click": function($event) {
          _vm.removeSpecialTime(day._id)
        }
      }
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "basic-box__btns basic-box__btns_placing"
  }, [_c('button', {
    staticClass: "basic-box__btn basic-blue-btn full-width",
    on: {
      "click": function($event) {
        _vm.showPicker('Date', true)
      }
    }
  }, [_vm._v("\n\t\t\t\tДобавить особый день\n\t\t\t")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-250eccb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SpecialDayEditor.vue
// module id = 595
// module chunks = 0